import { render, staticRenderFns } from "./DocumentIntake.vue?vue&type=template&id=01ed0b69&scoped=true&"
import script from "./DocumentIntake.vue?vue&type=script&lang=js&"
export * from "./DocumentIntake.vue?vue&type=script&lang=js&"
import style0 from "./DocumentIntake.vue?vue&type=style&index=0&id=01ed0b69&prod&scoped=true&lang=css&"
import style1 from "./DocumentIntake.vue?vue&type=style&index=1&id=01ed0b69&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ed0b69",
  null
  
)

export default component.exports